import React from 'react';
import { Alert, Portal, Snackbar, TableCell, TableRow } from '@mui/material';
import ThumbnailPicker from './thumbnails/ThumbnailPicker';
import useThumbnailDrop from './thumbnails/useThumbnailDrop';
import useVideoThumbnail from './thumbnails/useVideoThumbnail';

export default function VideoThumbnailRow({
  component: Component = TableRow,
  kind,
  videoId,
  videoTitle,
  enabled = true,
  children,
  sx,
  ...props
}) {
  const saved = useVideoThumbnail(kind, enabled ? videoId : null);
  const { dragging, dropProps } = useThumbnailDrop(
    saved.change,
    !enabled || saved.busy || saved.loading,
  );
  const preview = enabled ? (
    <ThumbnailPicker
      compact
      dropEnabled={false}
      loading={saved.loading}
      thumbnail={saved.thumbnail}
      onFiles={saved.change}
      busy={saved.busy}
      disabled={saved.loading}
      highlighted={dragging}
      title={videoTitle}
    />
  ) : null;
  const table = Component === TableRow;
  const cells = React.Children.toArray(children);
  // The existing first cell holds the selection checkbox.
  if (table && enabled)
    cells.splice(
      1,
      0,
      <TableCell
        key="thumbnail"
        sx={{ width: 88, px: 1.5 }}
        onClick={(event) => event.stopPropagation()}
      >
        {preview}
      </TableCell>,
    );
  // Keep notification markup outside the table.
  return (
    <>
      <Component
        {...props}
        {...dropProps}
        sx={{
          ...sx,
          ...(dragging
            ? {
                bgcolor: '#e6eafd',
                outline: '2px solid #667eea',
                outlineOffset: -2,
              }
            : {}),
        }}
        {...(!table ? { leading: preview } : {})}
      >
        {table ? cells : children}
      </Component>
      <Portal>
        <Snackbar
          open={Boolean(saved.error || saved.notice)}
          autoHideDuration={5000}
          onClose={saved.clearNotice}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            severity={saved.error ? 'error' : 'success'}
            onClose={saved.clearNotice}
          >
            {saved.error || saved.notice}
          </Alert>
        </Snackbar>
      </Portal>
    </>
  );
}
